import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const r = a((l, e) => /* @__PURE__ */ o.jsx(
  n,
  {
    ref: e,
    ...l,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...i,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M30.866 17.985a4 4 0 0 0 0-3.97l-5.714-10A4 4 0 0 0 21.679 2H10.32a4 4 0 0 0-3.473 2.015l-5.714 10a4 4 0 0 0 0 3.97l5.714 10A4 4 0 0 0 10.321 30H21.68a4 4 0 0 0 3.473-2.015zm-12.601-1.079c-.118 2.198-1.553 3.264-3.58 3.264-2.373 0-3.844-1.594-3.844-4.336 0-2.772 1.494-4.4 3.855-4.4 2.057 0 3.504 1.148 3.574 3.234h-1.863c-.094-1.113-.72-1.7-1.693-1.7-1.237 0-1.975 1.003-1.975 2.83 0 1.817.72 2.82 2.022 2.82.966 0 1.535-.68 1.623-1.712zM20.919 20h-1.775v-8.402h1.775z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "ClindamycinIcon";
export {
  r as ClindamycinIcon,
  r as default
};
//# sourceMappingURL=index.js.map
